"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLogoMenuAig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 56,
    viewBox: "0 0 86 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.374 15.656l-11.496 24.7h4.016l2.753-6h10.572l2.592 6h4.08l-11.09-24.7h-1.427zm.662 6.799l3.664 8.398h-7.503l3.839-8.398zm19.465 17.901h-3.728v-24.7h3.728v24.7zM60.05 27.493h10.205v.817c0 1.855-.217 3.498-.655 4.926-.426 1.323-1.146 2.559-2.159 3.712-2.294 2.582-5.21 3.87-8.75 3.87-3.457 0-6.416-1.247-8.88-3.742-2.463-2.506-3.695-5.514-3.695-9.022 0-3.583 1.255-6.623 3.76-9.118 2.507-2.507 5.555-3.759 9.15-3.759 1.931 0 3.732.392 5.407 1.178 1.6.785 3.172 2.062 4.719 3.829l-2.656 2.542c-2.025-2.698-4.495-4.046-7.405-4.046-2.614 0-4.806.901-6.576 2.704-1.769 1.77-2.655 3.987-2.655 6.652 0 2.753.987 5.02 2.96 6.8 1.846 1.654 3.845 2.48 5.999 2.48 1.833 0 3.48-.617 4.943-1.851 1.46-1.244 2.275-2.734 2.447-4.468h-6.16v-3.504z",
    fill: "#001871"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 50h81.36V6H0v44zm3.384-3.393h74.592V9.392H3.384v37.215z",
    fill: "#001871"
  }));
}

var _default = SvgLogoMenuAig;
exports["default"] = _default;